import React from "react";
import Classes from "./Footer.module.css";
import { scrollToElement } from "../../utils/scrollToElement";
import { useNavigate } from "react-router-dom";

export default function Footer() {
    const navigateTo = useNavigate();
    const phoneNumber = '+971502466347';
    const whatsappURL = `https://wa.me/${phoneNumber}`;

    return (
        <footer className={Classes.footer} id="footer" >
            <div className={Classes.topArea}>
                {/* Left: Logo + CTA */}
                <div className={Classes.leftBlock}>
                    <a href="/" className={Classes.logoCon} style={{ height: '2.2rem', width: 'fit-content' }} >
                        <img src='/images/logoWhite.png' alt='logo' style={{ height: '100%' }} draggable={false} />
                        <h3>Luxaywear</h3>
                    </a>
                    <div className={Classes.ctaCard}>
                        <p>Order now on WhatsApp.</p>
                        {/* <a
                            href="https://cal.com/brandon-feinstein-apkvsi/30min"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="white" height='20px' viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" /></svg>
                                <h5>WhatsApp</h5>
                            </button>
                        </a> */}
                        <h5>
                            You can reach us anytime via WhatsApp support team. <br /><br />
                            WhatsApp:  <a href={whatsappURL} target="_blank" rel="noopener noreferrer">(+971) 502466347</a> <br />
                            Instagram: <a href="https://www.instagram.com/luxaywear/" target="_blank" rel="noopener noreferrer" >@luxaywear</a> <span style={{ fontWeight: '300' }} > or </span> <a href="https://www.instagram.com/luxaywear_com/" target="_blank" rel="noopener noreferrer" >@luxaywear_com</a>
                        </h5>
                    </div>
                </div>

                {/* Right: Footer navigation columns */}
                <div className={Classes.navColumns}>
                    <div>
                        <h4>Product</h4>
                        <ul>
                            <li> <h5 onClick={() => { navigateTo('/all-products') }} >Products </h5> </li>
                            <li> <h5 onClick={() => { scrollToElement('brands-section', -50) }} >Brands </h5> </li>
                            <li> <h5 onClick={() => { scrollToElement('reviews-section', -50) }} >Reviews </h5> </li>
                        </ul>
                    </div>
                    <div>
                        <h4>Company</h4>
                        <ul>
                            <li> <h5 onClick={() => { scrollToElement('faq', -50) }} >FAQ </h5> </li>
                            <li> <h5>Blog</h5> </li>
                            <li> <h5>Careers</h5> </li>
                        </ul>
                    </div>
                    <div>
                        <h4>Legal</h4>
                        <ul>
                            <li> <a href="/data-security" target='_blank' > <h5>Data Security</h5> </a> </li>
                            <li> <a href="/terms-of-service" target='_blank' > <h5>Terms of Service</h5> </a> </li>
                            <li> <a href="/privacy-policy" target='_blank' > <h5>Privacy Policy</h5> </a> </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Divider line */}
            <div className={Classes.divider}></div>

            {/* Bottom bar: copyright + social */}
            <div className={Classes.bottomBar}>
                <span><h5>© 2024 Luxaywear, All rights reserved.</h5></span>
                {/* Example LinkedIn icon or any social link */}
                {/* <a
                    href="https://www.linkedin.com/company/evolvionio"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={Classes.socialLink}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="white" height='23px' viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" /></svg>
                </a> */}
            </div>
        </footer>
    );
}
